import { createActionTypes } from "@helpers/redux-helpers";

export const getMyPromotersActionTypes = createActionTypes("promoters/my");

export const getMyPromotersPortionActionTypes = createActionTypes(
  "promoters/my/portion",
);

export const getPromotersByIdActionTypes = createActionTypes("promoters/byId");

export const getPromotersByIdPortionActionTypes = createActionTypes(
  "promoters/byId/portion",
);
